import CaseFirstView from 'components/cases/common/CasesFirstView/'
import OverView from 'components/cases/common/Overview/'
import MobileAppDevelopment from 'components/services/common/MobileAppDevelopment'
import CaseStudy from 'components/home/CaseStudy'
import { firstViewItem, overviewTitle, overviewItem, issueSolutionItems } from './MirronItems'
import FooterCTA from 'components/common/FooterCTA'
import styles from './Mirron.module.scss'

const Mirron = (): JSX.Element => {
  return (
    <section>
      <CaseFirstView firstViewItem={firstViewItem} />
      <OverView overviewItem={overviewItem} issueSolutionItems={issueSolutionItems} overviewTitle={overviewTitle} />
      <FooterCTA />
      <div className={styles.mobileAppWrapper}>
        <MobileAppDevelopment />
      </div>
      <div className={styles.line}>
        <CaseStudy enTitle="Case study" jaTitle="事例" tagType="h2" />
      </div>
    </section>
  )
}

export default Mirron
